import { useRuntimeConfig } from "#imports";
import * as Sentry from "@sentry/nuxt";

if (useRuntimeConfig().public.USE_SENTRY === "true") {
  Sentry.init({
    dsn: useRuntimeConfig().public.SENTRY_DSN,
    sampleRate: 0.05,
    integrations: [Sentry.piniaIntegration(usePinia())],
  });
}
